<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        data(){
            return {
                limits: null,
            };
        },
        props:{
            title: {
                default(){
                    return 'Select Side Panel Style';
                }
            },
            frameMaterial: {
                required: true,
            },
            frameColourExternal: {
                required: true,
            },
            frameColourInternal: {
                required: true,
            },
            externalColour: {
              required: false,
              default: 0,
            },
            doorColourInternal: {
              required: false,
              default: 0,
            },
            measurementKey: {
                required: true,
            },
            measurementLabel: {
                required: true,
            },
            measurement: {
                required: true,
            },
            frameStyleId: {
                required: true,
            },
            doorRange: {
                required: true,
            },
            slab: {
              required: false,
              default: 0,
            },
            securedByDesign: {
                required: false,
                default: 0,
            },
            panelCategory: {
                required: false,
                default: 0,
            },
        },
        computed: {
            valid_selection(){
                if (!this.options_loaded) {
                    return false;
                }

                return this.filtered_option_list.find(y => {
                            return y.value == this.localTarget;
                        }) !== undefined;
            },
            thumbURL(){
                return '/thumb/sidepanel/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/side-panel?frame_colour_external=' + this.frameColourExternal + '&frame_colour_internal=' + this.frameColourInternal + '&framematerial=' + this.frameMaterial + '&frame_id=' + this.frameStyleId + '&door_range=' + this.doorRange + '&slab=' + this.slab + '&external_colour=' + this.externalColour + '&door_colour_internal=' + this.doorColourInternal + '&secured_by_design=' + this.securedByDesign + '&panel_category=' + this.panelCategory;
            },
            cache_key(){
                return '_' + this.frameMaterial + '_' + this.frameColourExternal + '_' + this.frameColourInternal + '_' + this.frameStyleId + '_' + this.doorRange + '_' + this.slab + '_' + this.externalColour + '_' + this.doorColourInternal + '_' + this.securedByDesign + '_' + this.panelCategory;
            },
            from_limit(){
                if(this.limits === null || this.limits[this.measurementKey] === undefined){
                    return 0;
                }

                return this.limits[this.measurementKey].min;
            },
            to_limit(){
                if(this.limits === null || this.limits[this.measurementKey] === undefined){
                    return 0;
                }

                return this.limits[this.measurementKey].max;
            }
        },
        methods: {
            select_first(){
                if (!Array.isArray(this.filtered_option_list)) {
                    this.localTarget = undefined;
                    return;
                }

                if ((this.filtered_option_list.length === 0)) {
                    this.localTarget = undefined;
                    return;
                }

                var new_value = this.filtered_option_list[0];

                this.localTarget = new_value.value;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        },
        mounted() {
            window.emitter.on('limits-updated', (limits) => {
                this.limits = limits;
            })
        },
        onUnmounted() {
            window.emitter.off('limits-updated')
        },
    }
</script>
